/**
 * Carrier identifier used by rate tables. Extracted from
 * `redo/model/src/rate-table/rate-table-mapping.ts` (its file imports model
 * types for other exports) so leaf packages can reference it without a cycle.
 * The origin file stays in redo/model and re-imports this.
 *
 * Persisted to Mongo — keep in sync with the `typedEnum` registration in
 * `redo/backend/db/schema/src/team/OutboundLabelSettings.ts`.
 */
export enum RateTableCarrier {
  USPS = "USPS",
  USPS_RETURNS = "USPSReturns",
  FEDEX = "FedEx",
  UPS = "UPS",
  UPS_SUREPOST = "UPSSurePost",
  Amazon = "Amazon",
  DHL_EXPRESS = "DHLExpress",
  VEHO = "Veho",
  FIRST_MILE = "FirstMile",
  AUSTRALIA_POST = "AustraliaPost",
  CANADA_POST = "CanadaPost",
  DHL_ECS = "DHL_ECS",
  APC = "APC",
  GLS = "GLS",
  ASENDIA = "Asendia",
  ROYAL_MAIL_V3 = "RoyalMailV3",
  SPEE_DEE = "SpeeDee",
  PASSPORT_GLOBAL = "PassportGlobal",
  LANDMARK_GLOBAL = "LandmarkGlobal",
  ONTRAC = "OnTracV3",
  UNIUNI = "UniUni",
  EPOST_GLOBAL = "ePostGlobal",
}
